<template>
    <div>
        <b-alert
            v-if="subscribedToCreatorUserId(profile.id)"
            variant="success"
            show
            class="p-3 rounded-0 border-0 mb-0"
        >
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <font-awesome-icon icon="fa-light fa-check" />
                    You're subscribed
                </div>
                <b-btn
                    @click="manageSubscription"
                    variant="light"
                    pill
                    size="sm"
                >
                    <font-awesome-icon icon="fa-duotone fa-pencil" />
                    {{ $t("Manage Subscription") }}
                </b-btn>
            </div>
        </b-alert>
        <b-alert
            v-else
            variant="success"
            show
            class="p-3 rounded-0 border-0 mb-0"
        >
            <b-btn
                @click="subscribeCreator"
                variant="light"
                block
                class="rounded-0 mt-0"
                :size="$screen.lg ? 'lg' : 'sm'"
            >
                <div>
                    <font-awesome-icon
                        icon="fa-duotone fa-clapperboard-play"
                        size="lg"
                    />
                </div>
                {{ $t("Subscribe") }}
            </b-btn>
        </b-alert>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    computed: {
        offerSubscribe() {
            return (
                this.showUncensoredCreatorActions &&
                !this.subscribedToCreatorUserId(this.profile.id)
            );
        },
        ...mapState("profile", ["profile"]),
        ...mapGetters("profile", ["showUncensoredCreatorActions"]),
        ...mapGetters("creatorSubscription", [
            "subscribedToCreatorUserId",
            "isLegacySubscription",
        ]),
    },
    methods: {
        manageSubscription() {
            this.$store.dispatch("setting/editSetting", "subscriptions");
        },
        subscribeCreator() {
            this.$store.dispatch(
                "creatorSubscription/fromProfile",
                this.profile
            );
        },
    },
};
</script>